import { Toaster } from "sonner";
import { useEffect } from "react";
import SmoothScroll, { scrollToId } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { DigitalEstate } from "@/components/site/DigitalEstate";
import { Companion } from "@/components/site/Companion";
import { WhatRemains } from "@/components/site/WhatRemains";
import { Fidelity } from "@/components/site/Fidelity";
import { Protection } from "@/components/site/Protection";
import { MemoryConstellation } from "@/components/site/MemoryConstellation";
import { Experiences } from "@/components/site/Experiences";
import { Inheritance } from "@/components/site/Inheritance";
import { TrustPillars } from "@/components/site/TrustPillars";
import { Institutional } from "@/components/site/Institutional";
import { About } from "@/components/site/About";
import { Footer } from "@/components/site/Footer";
import AmbientLayer from "@/components/site/AmbientLayer";
import Feathers from "@/components/site/Feathers";

export default function Landing() {
  useEffect(() => {
    const hash = window.location.hash?.slice(1);
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash), 700);
    return () => clearTimeout(t);
  }, []);

  return (
    <SmoothScroll>
      <div className="App bg-es-bg text-es-fg relative">
        <div className="grain" />
        <AmbientLayer />
        <Feathers />
        <Header />
        <div id="dissolve-scope">
          <main>
            <Hero />
            <Manifesto />
            <DigitalEstate />
            <Companion />
            <WhatRemains />
            <Fidelity />
            <Protection />
            <MemoryConstellation />
            <Experiences />
            <Inheritance />
            <TrustPillars />
            <Institutional />
            <About />
          </main>
          <Footer />
        </div>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1C1C19",
              color: "#F9F8F6",
              border: "none",
              borderRadius: "999px",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </div>
    </SmoothScroll>
  );
}
